import get from 'lodash.get';
import { OFFER_CARD_COLORS, OFFER_CARD_COLOR_MAP } from './constants';
import { OfferCardContainer } from './styles';

export interface ICardsOfferProps {
  logo: string;
  description: string;
  color: keyof typeof OFFER_CARD_COLORS;
  discount: string;
}

const CardsOffer: React.FC<ICardsOfferProps> = ({
  logo,
  description,
  color,
  discount,
}): JSX.Element => {
  const colorCode = get(
    OFFER_CARD_COLOR_MAP,
    color,
    OFFER_CARD_COLOR_MAP['blue']
  );
  return (
    <OfferCardContainer>
      <div
        className={`rounded-md flex mx-3 h-32 items-center ${colorCode.bg} bg-opacity-50 sm:mx-1.5 sm:mb-5`}
      >
        <div
          className={`w-1/3 py-6 px-2 h-full flex items-center border-r-sm border-dashed ${colorCode.border} justify-center coupon-card-desc`}
        >
          <div className="pl-4 pt-4">
            <p className={`text-s-48 font-bold text-center ${colorCode.text}`}>
              {discount}
            </p>
          </div>
        </div>
        <div className="w-2/3 py-6 px-4 coupon-card-apply">
          <img src={logo} width="120" height="30" alt="logo" />
          <p className="text-base text-font-550 sm:text-s-14">{description}</p>
        </div>
      </div>
    </OfferCardContainer>
  );
};

export { CardsOffer };
